export const VALUATION_ORIGIN_COOKIE = "valuation_origin";

export const VALUATION_ORIGINS = {
  HOMEPAGE: "homepage",
  ORGANIC: "organic",
} as const;

export const HOMEPAGE_VALUATION_UTM = {
  source: "ackodrive",
  medium: "homepage",
} as const;

export const buildHomepageValuationHref = (href: string) => {
  const separator = href.includes("?") ? "&" : "?";
  return `${href}${separator}utm_source=${HOMEPAGE_VALUATION_UTM.source}&utm_medium=${HOMEPAGE_VALUATION_UTM.medium}`;
};
